import React, { useEffect } from "react";
import { Button, Grid, Stack } from "@mui/material";
import { UsersAutoSearchByRole } from "../../../../components/AutoCompleteSearches/UsersAutoSearchByRole";
import { useDispatchWrapper } from "../../../../hooks";
import { useCurrentUserId } from "../../../../hooks/useAssignedTo";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../../redux/initialStoreState";
import {
  addAutomobilePolicyChangeV2,
  clearAutomobilePolicyReqState,
  fetchAutomobilePolicyChangeReqV2Async,
} from "../../../../redux/automobilePolicyChangeReq/automobilePolicyChangeReqActions";
import { useFormik } from "formik";
import {
  ControlledCustomSelect,
  CustomFormLabel,
} from "../../../../components/formsComponents";
import { TASK_STATUS } from "../../../../constants/constants";
import { FieldSet } from "../../../../components/FieldSet/FieldSet";

export const AutomobileAssignedTo: React.FC<{
  customerPolicyId: number | null;
  customerId: number | null;
  change_request_code: string | null;
  status: string;
  onComplete: (data?: {
    assigned_to_id: string;
    assigned_to_name: string | null;
  } ) => void;
  onClose: () => void;
}> = (props) => {
  const {
    customerPolicyId,
    change_request_code,
    onComplete,
    customerId,
    onClose,
    status
  } = props;
  const id = useCurrentUserId();

  const { policyChangeData, loading } = useSelector(
    (storeState: IStoreState) => storeState.automobile.policyChangeReq
  );

  const dispatch = useDispatchWrapper();

  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    setFieldValue,
    setValues,
  } = useFormik({
    initialValues: {
      ...policyChangeData,
    },
    validate: (values) => {},
    onSubmit: (values) => {
      if (customerPolicyId) {
        dispatch(
          addAutomobilePolicyChangeV2(
            {
              ...values,
              assigned_to_id: String(values.assigned_to_id),
              customer_id: customerId,
              customer_policy_id: customerPolicyId,
              status: values.status,
            },
            policyChangeData,
            true,
            (isSuccess) => {
              if (isSuccess) {
                onComplete({
                  assigned_to_id: values.assigned_to_id,
                  assigned_to_name: values.assigned_to_name
                });
              }
            }
          )
        );
      }
    },
  });

  const handleCancel = () => {
    onClose();
  };

  useEffect(() => {
    if (policyChangeData) {
      setValues({
        ...policyChangeData,
        assigned_to_id: policyChangeData.assigned_to_id || (id as any),
      });
    }
  }, [policyChangeData, id]);

  useEffect(() => {
    if (customerPolicyId && change_request_code) {
      dispatch(
        fetchAutomobilePolicyChangeReqV2Async(customerPolicyId, change_request_code)
      );
    }

    return () => {
      dispatch(clearAutomobilePolicyReqState());
    };
  }, [change_request_code, customerPolicyId, dispatch]);

  const isCompleted =status === "Completed";

  return (
    <FieldSet disabled={isCompleted} >
    <form onSubmit={handleSubmit}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <CustomFormLabel>Status</CustomFormLabel>
          <ControlledCustomSelect
            fullWidth
            value={values.status}
            name="status"
            onChange={handleChange}
            placeholder="Select one"
            displayEmpty
            options={TASK_STATUS}
          />
        </Grid>
        <Grid item xs={12}>
          <UsersAutoSearchByRole
            value={values.assigned_to_id}
            label="Assign To"
            fullWidth
            onSelect={(data) => {
              setFieldValue("assigned_to_id", data.user_fact_id);
              setFieldValue(
                "assigned_to_name",
                data.first_name + " " + data.last_name
              );
            }}
          />
        </Grid>
      </Grid>

      <Stack direction={"row"} spacing={1} mt={4}>
        <Button variant="contained" size="small" disabled={isCompleted} type="submit">
          Apply
        </Button>
        <Button
          variant="contained"
          size="small"
          color="error"
          disabled={isCompleted}
          onClick={handleCancel}
        >
          Cancel
        </Button>
      </Stack>
    </form>
    </FieldSet>
  );
};
